module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Credit-card-191e3d25d3b0f688863ad031ca0e5a37.svg";